import { DateTime } from 'luxon';
import { map, capitalize } from 'lodash';
var RestaurantHours = /** @class */ (function () {
    function RestaurantHours(data) {
        this.formattedDays = this.getFormattedDays(data);
    }
    RestaurantHours.prototype.getFormattedDays = function (days) {
        var _this = this;
        var formattedDays = map(days, function (day) {
            return _this.getFormattedDay(day);
        });
        return formattedDays;
    };
    RestaurantHours.prototype.getFormattedDay = function (day) {
        var restaurantDay = {
            startTime: day.start_time,
            endTime: day.end_time,
        };
        var formattedDay = {
            relativeDayName: this.getRelativeDayName(restaurantDay),
            startHour: this.getStartHour(restaurantDay),
            endHour: this.getEndHour(restaurantDay)
        };
        return formattedDay;
    };
    RestaurantHours.prototype.getStartHour = function (day) {
        var dateISO = DateTime.fromISO(day.startTime);
        return dateISO.toLocaleString(DateTime.TIME_SIMPLE);
    };
    RestaurantHours.prototype.getEndHour = function (day) {
        var dateISO = DateTime.fromISO(day.endTime);
        return dateISO.toLocaleString(DateTime.TIME_SIMPLE);
    };
    RestaurantHours.prototype.getRelativeDayName = function (day) {
        var dateISO = DateTime.fromISO(day.startTime);
        var today = DateTime.local();
        if (dateISO <= today.plus({ days: 1 })) {
            return capitalize(dateISO.toRelativeCalendar());
        }
        return dateISO.toLocaleString({ weekday: 'long' });
    };
    return RestaurantHours;
}());
export default RestaurantHours;



//////////////////
// WEBPACK FOOTER
// ./src/models/RestaurantHours.ts
// module id = null
// module chunks = 